module.exports = __webpack_public_path__ + "user-dashboard.56115521832868821304.jpg";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/user-dashboard.jpg
// module id = ../../../../../src/assets/img/user-dashboard.jpg
// module chunks = styles